import type { FlowEditorSDK } from '@wix/yoshi-flow-editor';

import { updateGlobalControllerWithRoutes } from '../../../editor/controller/global-controller';
import { buildRoutesFromSlots } from '../../../editor/controller/routes-utils';
import { getInstalledPluginsSlots } from '../../../editor/services/slots';

/** @deprecated */
export const populateGlobalControllerWithRoutes = async (
  editorSDK: FlowEditorSDK,
) => {
  const slots = await getInstalledPluginsSlots(editorSDK);
  const routes = await buildRoutesFromSlots(editorSDK, slots);

  return updateGlobalControllerWithRoutes(editorSDK, routes);
};
